// extracted by mini-css-extract-plugin
export default {"item":"vopqxttfYtm5n8l6PGXK"};